
import { Dayjs } from "dayjs";
import { TypeFare, TypeSegment } from "@/lib/redux/features/flight/type";
import { getDatetimeSegment } from "./getDatetimeSegment";

export const getDurationSegments = (segments: TypeSegment[], fareData?: TypeFare): {
  hours: number,
  mins: number,
  startTime: Dayjs,
  endTime: Dayjs,
} => {
  const lastSeg = segments[segments.length - 1]
  const firstSeg = segments[0]
  const endTime = getDatetimeSegment(lastSeg.endTime, lastSeg.endTimeZoneOffset)
  const startTime = getDatetimeSegment(firstSeg.startTime, firstSeg.startTimeZoneOffset)

  let duration = lastSeg.flightNumber === firstSeg.flightNumber
    ? parseFloat(lastSeg.duration)
    : segments.reduce((t, seg) => (t + parseFloat(seg.duration)), 0)
  duration = duration / 60
  
  const hours = Math.abs(Math.floor(duration))
  const mins = Math.abs(Math.round((duration - hours) * 60))

  return { hours, mins, endTime, startTime }
}